import RenderTemplate from '../RenderTemplate'
import firstStepsApi from '../../utils/firstStepsApi'

const MotsetsimLegal = () => (
    <RenderTemplate
        fetchFn={firstStepsApi.getLegalTermsMotsetsimText}
        component="div"
        display="block"
        color="primary"
        variant="body2"
    />
)

export default MotsetsimLegal
